export default {
    name: 'video',
    component: () => import('@/layouts/VideocallLayout.vue'),
    children: [
        {
            path: 'videocall/:room_name/:redirect_route?',
            name: 'videocall',
            component: () => import('@/modules/videocall-group/views/Index.vue')
        }
    ]
}
